import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useProductResultsContext } from "../../../../context/productResults.context";

type OpenFacetsButtonProps = {
    className?: string;
};

const OpenFacetsButton = ({ className }: OpenFacetsButtonProps) => {
    const { t } = useGranite();
    const { setMobileFacetsOpen } = useProductResultsContext();

    const handleOnFilterButtonClick = () => setMobileFacetsOpen(() => true);

    return (
        <Button
            type={"button"}
            className={cn("tw:text-left tw:cursor-pointer", className)}
            color={"gray"}
            onClick={handleOnFilterButtonClick}
        >
            <i className={cn("las la-filter", "tw:mr-2")} />
            {t("search.refinements.showFiltersButton")}
        </Button>
    );
};

export { OpenFacetsButton };
